import * as Sentry from '@sentry/react';
import React, { ReactNode } from 'react';

import ErrorBoundaryFallback from './ErrorBoundaryFallback';

interface Props {
  children: ReactNode;
  fallback?: React.ComponentType<{
    error: unknown;
    errorId?: string;
  }>;
}

const ErrorBoundary: React.FC<Props> = ({ children, fallback }) => {
  const FallbackComponent = fallback || ErrorBoundaryFallback;

  return (
    <Sentry.ErrorBoundary
      fallback={({ error, eventId }) => (
        <FallbackComponent error={error} errorId={eventId} />
      )}
    >
      {children}
    </Sentry.ErrorBoundary>
  );
};

export default ErrorBoundary;
